import src from "IMAGE";
export default { src, width: 950, height: 950, blurWidth: 0, blurHeight: 0};
